import React from "react";
import { Card, Grid, Typography, Box } from "@mui/material";

function FreebieCartItemCard({ item }) {
  return (
    <Card
      className="freebieCard"
      elevation={0}
      sx={{
        borderRadius: "0 0 22px 22px", 
        backgroundColor: "#B8FF9A",
        px: 2.2,
        py: 1.6,
      }}
    >
      <Grid container alignItems="center">
        <Grid item xs={7}>
          <Typography
            sx={{
              fontWeight: 900,
              fontSize: "14px",
              lineHeight: 1.1,
              color: "#0B0B0B",
            }}
          >
            {item?.product?.name}
          </Typography>

          <Typography
            sx={{
              mt: 0.5,
              fontSize: "12px",
              color: "#2F2F2F",
              opacity: 0.85,
              lineHeight: 1.1,
            }}
          >
            Please remove coupon to remove this <br /> item
          </Typography>
        </Grid>

        {/* MIDDLE: Qty */}
        <Grid item xs={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: "14px",
              color: "#0B0B0B",
            }}
          >
            {item?.quantity ?? 1}
          </Typography>
        </Grid>

        {/* RIGHT: FREE! */}
        <Grid item xs={3} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography
            sx={{
              fontWeight: 900,
              fontSize: "14px",
              color: "#16A34A",
              letterSpacing: "0.5px",
            }}
          >
            FREE!
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

export default FreebieCartItemCard;
